import { Spin } from 'antd'

export const PageLoading = () => (
  <div
    style={{
      width: '100%',
      minHeight: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    }}
  >
    <Spin size={'large'} />
  </div>
)
